// extracted by css-extract-rspack-plugin
export default {"root":"root-E_FzNa","add":"add-zKAfYd","title":"title-f08hDu","empty":"empty-UqT8Ls"};